import './title-section.css';
import iconAeromexico from "../../assets/imgs/shared/icono_amc.svg";

function TitleSection({title}) {
    return (
        <>
            <div className="titleSection">
                <div className="container">
                <div className="titleContainer">
                    <h2>{title} </h2>
                </div>
                </div>
            </div>
        </>
    )
};

export default TitleSection;